"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideCartDrawer = exports.SIDE_CART_DRAWER_WIDTH = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const BrandThemeProvider_1 = require("../BrandThemeProvider");
const flora_react_1 = require("@grupoboticario/flora-react");
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
const tag_book_sellout_1 = require("@grupoboticario/tag-book-sellout");
const react_1 = require("react");
const _cart_1 = require("../../@cart");
const types_1 = require("../../types");
const utils_1 = require("../../utils");
const SideCartDrawer_styled_1 = require("./SideCartDrawer.styled");
const services_1 = require("../../services");
const react_query_1 = require("@tanstack/react-query");
const vd_customer_ui_core_react_1 = require("@grupoboticario/vd-customer-ui-core-react");
const useCustomer_1 = require("../../hooks/useCustomer");
exports.SIDE_CART_DRAWER_WIDTH = 330;
const redirect = (url) => {
    window.location.href = url;
};
/**
 * @Component SideCartDrawer
 * @Description Componente que exibe o carrinho de compras do usuário
 * @param variant - Variante do menu
 * @param catalogName - Nome da loja da RE no catálogo
 * @param catalogSlug - nome da loja da RE usado na URL
 * @param resellerWhatsapp - Número de whatsapp do revendedor
 * @param businessUnit - Unidade de negócio
 * @param cycleInfo - Informações do ciclo
 * @param onClose - Função de callback para fechar o drawer
 * @param open - Estado de abertura do drawer
 * @example
 * <SideCartDrawer
 *  variant="temporary"
 *  catalogName="Catálogo"
 *  catalogSlug="catalogo"
 *  resellerWhatsapp="5511999999999"
 *  businessUnit={{ id: '1', name: 'Unidade de negócio' }}
 *  cycleInfo={{ number: 1, cycle: 'Ciclo 1' }}
 *  onClose={() => console.log('Fechou')}
 *  open={true}
 * />
 */
const SideCartDrawer = ({ variant, catalogName, catalogSlug, resellerWhatsapp, businessUnit, cycleInfo, onClose, onChooseMoreProducts, open = false, }) => {
    const containerRef = (0, react_1.useRef)(null);
    const queryClient = new react_query_1.QueryClient();
    const { isRecognized } = (0, useCustomer_1.useCustomer)();
    const isTemporary = variant === 'temporary';
    const { cart, totalItems, removeItem, updateItemQuantity, placeOrder, isPlacingOrder, clearCart, placeOrderError, } = (0, _cart_1.useCart)();
    const { state, closeBag, openBag } = (0, _cart_1.useCartMenu)();
    const totalAmount = (0, _cart_1.getTotalPriceByCart)(cart);
    const handleSendOrder = (recognizedCustomerToken) => __awaiter(void 0, void 0, void 0, function* () {
        services_1.SideCartAnalyticsService.clickSendOrder();
        openBag();
        try {
            const orderBackofficeId = yield placeOrder({
                reseller: { catalogName, catalogSlug, whatsapp: resellerWhatsapp },
                businessUnit,
                cycleInfo: {
                    cycleNumber: cycleInfo.number,
                    cycle: cycleInfo.cycle || '',
                },
                items: cart,
                recognizedCustomerToken,
            });
            if (orderBackofficeId) {
                redirect(`/${catalogSlug}/pedido/${orderBackofficeId}/compartilhar`);
                clearCart();
            }
        }
        catch (error) {
            flora_react_1.Toaster.notify({
                kind: 'error',
                description: 'Ocorreu um erro ao enviar o pedido. Tente novamente.',
                origin: 'right-top',
            });
        }
    });
    (0, react_1.useEffect)(() => {
        if (placeOrderError) {
            flora_react_1.Toaster.notify({
                kind: 'error',
                description: 'Ocorreu um erro ao enviar o pedido. Tente novamente.',
                origin: 'right-top',
            });
        }
    }, [placeOrderError]);
    const { Component: CustomerRecognitionForm, startRecognitionFlow } = (0, vd_customer_ui_core_react_1.useCustomerRecognitionForm)({
        onSuccess: services_1.VWOAnalyticsService.dispatchVWOEventBefore('successOnCustomerRecognition', handleSendOrder),
        onSkipSignup: services_1.VWOAnalyticsService.dispatchVWOEventBefore('skipCustomerRecognition', handleSendOrder),
        ComponentOptions: {
            catalogName,
            formId: vd_customer_ui_core_react_1.FormContentPageId.MLD_CHECKOUT_EMBEDDED_FORM,
            type: 'modal',
            originIdentifier: catalogSlug,
        },
    });
    const handleCloseBag = () => {
        closeBag();
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    const handleClickProduct = (product) => {
        services_1.SideCartAnalyticsService.clickViewProduct();
        redirect(`/${catalogSlug}/produto/${product.id}`);
    };
    const handleClick = () => {
        (0, tag_book_sellout_1.genericEvent)({
            event: 'ga-event',
            category: `minhaloja:${businessUnit}:carrinho-lateral`,
            action: 'click:button',
            label: 'pedir',
        });
        (0, tag_book_sellout_1.customerPartialIdentificationEvent)({
            backOfficeId: '',
            businessUnit: types_1.BusinessUnitToOrganizationSlug[businessUnit],
            step: 'start',
        });
        services_1.SideCartAnalyticsService.beginCheckout((0, utils_1.getOrderList)());
        startRecognitionFlow({
            customerCookieKey: 'CHECKOUT_CF_ID',
            isEnabled: !(0, utils_1.isLogged)(),
        });
        if (!isRecognized) {
            closeBag();
        }
    };
    const handleChooseMore = () => {
        services_1.SideCartAnalyticsService.clickOnChooseMore();
        closeBag();
        onChooseMoreProducts === null || onChooseMoreProducts === void 0 ? void 0 : onChooseMoreProducts();
    };
    const handleRemoveItem = (product) => {
        services_1.SideCartAnalyticsService.clickRemoveItem();
        removeItem(product);
    };
    const handleIncrementItem = (product) => {
        services_1.SideCartAnalyticsService.clickIncrementItem();
        updateItemQuantity(product);
    };
    const handleDecrementItem = (product) => {
        services_1.SideCartAnalyticsService.clickDecrementItem();
        updateItemQuantity(product);
    };
    return ((0, jsx_runtime_1.jsxs)(vd_customer_ui_core_react_1.QueryClientProvider, Object.assign({ client: queryClient }, { children: [(0, jsx_runtime_1.jsx)("div", { ref: containerRef }), (0, jsx_runtime_1.jsx)(CustomerRecognitionForm, { container: containerRef.current }), (0, jsx_runtime_1.jsx)(material_1.Drawer, Object.assign({ "data-testid": "side-cart-drawer", variant: variant, open: open || state.isOpen, onClose: handleCloseBag, anchor: "right", PaperProps: {
                    sx: {
                        borderTopLeftRadius: 8,
                        marginTop: isTemporary ? 0 : 7,
                        width: exports.SIDE_CART_DRAWER_WIDTH,
                    },
                } }, { children: (0, jsx_runtime_1.jsxs)(BrandThemeProvider_1.WithTheme, Object.assign({ css: {
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        paddingBottom: '170px',
                        '@tablet': {
                            paddingBottom: 'calc(170px + $14)',
                        },
                    } }, { children: [(0, jsx_runtime_1.jsxs)(SideCartDrawer_styled_1.DrawerHeader, { children: [(0, jsx_runtime_1.jsx)(SideCartDrawer_styled_1.DrawerTitle, { children: "Sua sacola" }), (0, jsx_runtime_1.jsx)(SideCartDrawer_styled_1.CloseButton, Object.assign({ role: "button", "aria-label": "fechar", onClick: handleCloseBag }, { children: (0, jsx_runtime_1.jsx)(flora_react_icons_1.CrossIcon, { size: "24px", color: "$actionableDefault" }) }))] }), (0, jsx_runtime_1.jsx)(material_1.Divider, { sx: { m: 2 } }), cart.length ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SideCartDrawer_styled_1.DrawerContent, Object.assign({ "data-testid": "list-items" }, { children: cart.map((item, index) => ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(_cart_1.ProductCardShop, { product: item, index: index, handleDeleteProduct: handleRemoveItem, handleClickProduct: handleClickProduct, increment: handleIncrementItem, decrement: handleDecrementItem }), index < cart.length - 1 ? (0, jsx_runtime_1.jsx)(material_1.Divider, { sx: { my: 2 } }) : null] }, `${item.id}-${item.quantity}`))) })), (0, jsx_runtime_1.jsx)(SideCartDrawer_styled_1.DrawerFooter, Object.assign({ "data-testid": "summary-content" }, { children: (0, jsx_runtime_1.jsx)(_cart_1.CartSummary, { totalItems: totalItems, totalAmount: totalAmount, resellerName: (0, utils_1.isGenericReseller)(catalogSlug) ? catalogSlug : catalogName, isLoading: isPlacingOrder, handleOnClickOnSendOrder: services_1.VWOAnalyticsService.dispatchVWOEventBefore(types_1.VWOEvents.USER_CLICKED_ON_SEND_ORDER, handleClick), handleChooseMore: handleChooseMore }) }))] })) : ((0, jsx_runtime_1.jsx)(SideCartDrawer_styled_1.DrawerContent, Object.assign({ "data-testid": "empty-state" }, { children: (0, jsx_runtime_1.jsx)(_cart_1.CartEmptyState, { catalogName: catalogName, onChooseMoreProducts: handleChooseMore }) })))] })) }))] })));
};
exports.SideCartDrawer = SideCartDrawer;
